export default "__VITE_ASSET__1741577c__"